// extracted by mini-css-extract-plugin
module.exports = {"containerWithMargin":"components-viewBioModal-viewBioModal__containerWithMargin--1NB2j","closeWindowIcon":"components-viewBioModal-viewBioModal__closeWindowIcon--1nvHQ"};